export default (value) => value.slice(0, 1).toUpperCase().concat(value.slice(1));
